import React from "react";
import "./NotFound.css";

function NotFound() {
  return (
    <div className="not-found-page">
      <h1 className="not-found-header">404</h1>
      <h3>Not Found</h3>
      <h5>The requested page could not be found</h5>
    </div>
  );
}

export default NotFound;
